import {
  type Icon,
  IconBuildingStore,
  IconCalendar,
  IconChartBar,
  IconChartPie,
  IconCloudUpload,
  IconFileSpreadsheet,
  IconLayoutGrid,
  IconPrinter,
  IconShoppingCart,
  IconUsers,
} from "@tabler/icons-react";

export type Feature = {
  icon: Icon;
  title: string;
  description: string;
};

export const features: Feature[] = [
  {
    icon: IconShoppingCart,
    title: "Vendas e despesas",
    description:
      "Lance uma venda ou despesa em segundos. Várias formas de pagamento, troco calculado, atalhos no teclado, leitura de código de barras, e muito mais!",
  },
  {
    icon: IconLayoutGrid,
    title: "Catálogo e estoque",
    description:
      "Produtos com foto, preço, custo e estoque próprio. Sempre que uma venda é feita, o estoque é atualizado, simples assim.",
  },
  {
    icon: IconChartBar,
    title: "Balanço do estabelecimento",
    description:
      "Quanto entrou, quanto saiu, quanto sobrou. Edite vendas e despesas quando necessário. Filtre por data, cliente ou forma de pagamento",
  },
  {
    icon: IconUsers,
    title: "Clientes",
    description:
      "Veja quanto cada cliente comprou, quanto deve, e quais produtos compra com mais frequência. Tenha um relacionamento mais próximo e aumente suas vendas.",
  },
  {
    icon: IconCloudUpload,
    title: "Backup automático",
    description:
      "Seus dados sobem para o Google Drive periodicamente e sempre que o app é fechado. Se o computador queimar, seus dados estão seguros e prontos pra voltar.",
  },
];

export const extraFeatures: Feature[] = [
  {
    icon: IconBuildingStore,
    title: "Multi-estabelecimento",
    description: "Mais de um estabelecimento, cada um com seus próprios dados",
  },
  {
    icon: IconChartPie,
    title: "Relatórios",
    description: "Veja o que vende mais, quem compra mais e quem está devendo.",
  },
  {
    icon: IconFileSpreadsheet,
    title: "Exportação XLSX",
    description: "Leve seus dados pro Excel ou Google Sheets facilmente.",
  },
  {
    icon: IconCalendar,
    title: "Agenda",
    description: "Compromissos, entregas e lembretes direto no sistema.",
  },
  {
    icon: IconPrinter,
    title: "Impressão térmica",
    description: "Cupons e comprovantes em impressora térmica, sem desperdício.",
  },
];
